import {
  FooterBar,
  FooterStat,
  FooterStatText,
  FooterStatTitle,
  FooterStats,
} from "./ProgramMap.styles";
import { useI18n } from "../../../i18n/I18nProvider";

const PROGRAM_LESSON_COUNT = 265;

export const ProgramFooter = () => {
  const { t } = useI18n();
  return <FooterBar>
    <FooterStats>
      <FooterStat>
        <FooterStatTitle>{t("Программа")}</FooterStatTitle>
        <FooterStatText>
          {t("{{count}} уроков + пробные занятия", { count: PROGRAM_LESSON_COUNT })}
        </FooterStatText>
      </FooterStat>
      <FooterStat>
        <FooterStatTitle>{t("Навыки")}</FooterStatTitle>
        <FooterStatText>{t("Говорение, чтение, письмо и аудирование")}</FooterStatText>
      </FooterStat>
      <FooterStat>
        <FooterStatTitle>{t("Прогресс")}</FooterStatTitle>
        <FooterStatText>
          {t("Отслеживайте прогресс студента в его карточке")}
        </FooterStatText>
      </FooterStat>
    </FooterStats>
  </FooterBar>;
};
